import { create } from "zustand";

export interface IPanelCounterparty {
  code: string;
  desks?: string[];
}

export interface IPanelSelection {
  id: string;
  label: string;
  counterparties?: IPanelCounterparty[];
  active?: boolean;
  favourite?: boolean;
  editing?: boolean;
}

export type State = {
  userPanels: IPanelSelection[];
};

export type Action = {
  // eslint-disable-next-line no-unused-vars
  setUserPanels: (userPanels: State["userPanels"]) => void;
};

const savedPanelsStore = create<State & Action>((set) => ({
  userPanels: [],
  activePricesConfigIdNumberStoreArr: [],
  setUserPanels: (incomingData) => {
    set(() => ({
      userPanels: incomingData,
    }));
  },
}));

export default savedPanelsStore;
